import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as WizardClasses from '../WizardClasses'
import store, { resolveFieldLogic } from '../../../store'
import deepEqual from 'deep-equal'
import { resolveFieldConditions } from '@tecuity/wizard-utilities'
import format from 'date-fns/format'

class Summary extends Component {
  render() {
    const {
      steps,
      sections,
      fields,
      mode,
      originalValues,
      originalByFieldId,
      showDiff
    } = this.props
    return (
      <div className="confirm">
        <div className="row">
          {steps.map((step, i) =>
            step.includeInSummary ? (
              <ConfirmStep title={step.title} mode={mode} key={step.stepId}>
                {step.sectionOrder.map(sectionId => {
                  const section = sections[sectionId]
                  return (
                    <ConfirmSection title={section.title} mode={mode} key={section.sectionId}>
                      {section.fieldOrder
                        .filter(fieldId => fields[fieldId].includeInSummary === true)
                        .map(fieldId => {
                          const field = resolveFieldLogic(fields[fieldId])
                          
                          const fieldClass = new WizardClasses[field.fieldClass]()
                          const isNotInAmendmentMode = !showDiff
                          const fieldColSpan =
                            field.fieldClass !== 'Paragraph' && field.fieldClass !== 'UCCSearch'
                              ? 'col-6'
                              : 'col-12'
                          let valuesHaveChanged = originalValues.hasOwnProperty(field.name) &&
                            WizardClasses[field.fieldClass].compareValues(originalValues[field.name], field.value)

                          const conditionsSatsified = resolveFieldConditions(
                            field.conditions,
                            fields,
                            field.conditionsOperator
                          )

                          //Check if any dependent option fields have subfields with changed values.
                          if (field.hasOptionFields) {
                            const selectedOption = field.options.find(
                              option => option.value === field.value
                            )
                            if (selectedOption) {
                              selectedOption.fields.forEach(subfieldId => {
                                const subfield = fields[subfieldId]
                                let subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) &&
                                  WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value)

                                valuesHaveChanged =
                                  valuesHaveChanged === true ? true : subfieldValueHasChanged
                              })
                            }
                          }

                          //Check if any dependent check fields have subfields with changed values.
                          if (field.hasCheckFields) {
                            const checkedProp =
                              field.value === true ? 'checkedFields' : 'uncheckedFields'
                            field[checkedProp].forEach(subfieldId => {
                              const subfield = fields[subfieldId]
                              let subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) &&
                                WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value)

                              valuesHaveChanged =
                                valuesHaveChanged === true ? true : subfieldValueHasChanged
                            })
                          }

                          if (
                            (isNotInAmendmentMode ||
                              valuesHaveChanged ||
                              field.alwaysIncludeInSummary) &&
                            field.active &&
                            conditionsSatsified
                          ) {
                            if (field.type === 'repeater') {
                              if (
                                field.displayType === 'additional_article_layout' &&
                                field.value.length === 0
                              ) {
                                return null
                              }
                              return (
                                <DumbRepeater
                                  {...field}
                                  key={field.fieldId}
                                  originalByFieldId={originalByFieldId}
                                />
                              )
                            }

                            if (field.type === 'Signatures') {
                              return <SummarySignatures {...field} key={field.fieldId} />
                            } else if (field.hasOptionFields) {
                              const selectedOption = field.options.find(
                                option => option.value.toString() === field.value.toString()
                              )
                              const parentFieldValueHasChanged = originalValues.hasOwnProperty(field.name) &&
                                WizardClasses[field.fieldClass].compareValues(originalValues[field.name], field.value)

                              return (
                                <div className="field-divider" key={field.fieldId}>
                                  {parentFieldValueHasChanged ||
                                  isNotInAmendmentMode ||
                                  field.alwaysIncludeInSummary ? (
                                    <ConfirmField
                                      label={field.label}
                                      value={fieldClass.getHumanReadableValue(field, field.value)}
                                      colSpan={fieldColSpan}
                                      key={field.fieldId}
                                    />
                                  ) : null}
                                  {selectedOption
                                    ? selectedOption.fields
                                        .filter(subfieldId => fields[subfieldId].includeInSummary)
                                        .map(subfieldId => {
                                          const subfield = fields[subfieldId]
                                          const subfieldClass = new WizardClasses[
                                            subfield.fieldClass
                                          ]()
                                          const subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) &&
                                            WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value)

                                          const subfieldConditionsSatisfied = resolveFieldConditions(
                                            subfield.conditions,
                                            fields,
                                            subfield.conditionsOperator
                                          )
                                          return (subfieldValueHasChanged ||
                                            subfield.alwaysIncludeInSummary ||
                                            isNotInAmendmentMode) &&
                                            subfield.active &&
                                            subfieldConditionsSatisfied ? (
                                            <ConfirmField
                                              label={subfield.label}
                                              value={subfieldClass.getHumanReadableValue(
                                                subfield,
                                                subfield.value
                                              )}
                                              colSpan={fieldColSpan}
                                              key={subfield.fieldId}
                                            />
                                          ) : null
                                        })
                                    : null}
                                </div>
                              )
                            } else if (field.hasCheckFields) {
                              const checkedProp =
                                field.value === true ? 'checkedFields' : 'uncheckedFields'
                              const parentFieldValueHasChanged = originalValues.hasOwnProperty(field.name) &&
                                WizardClasses[field.fieldClass].compareValues(originalValues[field.name], field.value)

                              return (
                                <div className="field-divider" key={field.fieldId}>
                                  {parentFieldValueHasChanged ||
                                  isNotInAmendmentMode ||
                                  field.alwaysIncludeInSummary ? (
                                    <ConfirmField
                                      label={field.label}
                                      value={fieldClass.getHumanReadableValue(field, field.value)}
                                      colSpan={fieldColSpan}
                                      key={field.fieldId}
                                    />
                                  ) : null}
                                  {field[checkedProp]
                                    .filter(subfieldId => fields[subfieldId].includeInSummary)
                                    .map(subfieldId => {
                                      const subfield = fields[subfieldId]
                                      const subfieldClass = new WizardClasses[subfield.fieldClass]()
                                      const subfieldValueHasChanged = originalValues.hasOwnProperty(subfield.name) &&
                                        WizardClasses[subfield.fieldClass].compareValues(originalValues[subfield.name], subfield.value)

                                      const subfieldConditionsSatisfied = resolveFieldConditions(
                                        subfield.conditions,
                                        fields,
                                        subfield.conditionsOperator
                                      )
                                      return (subfieldValueHasChanged ||
                                        subfield.alwaysIncludeInSummary ||
                                        isNotInAmendmentMode) &&
                                        subfield.active &&
                                        subfieldConditionsSatisfied ? (
                                        <ConfirmField
                                          label={subfield.label}
                                          value={subfieldClass.getHumanReadableValue(
                                            subfield,
                                            subfield.value
                                          )}
                                          colSpan={fieldColSpan}
                                          key={subfield.fieldId}
                                        />
                                      ) : null
                                    })}
                                </div>
                              )
                            } else {
                              return (
                                <ConfirmField
                                  label={field.label}
                                  value={fieldClass.getHumanReadableValue(field, field.value)}
                                  colSpan={fieldColSpan}
                                  key={field.fieldId}
                                />
                              )
                            }
                          } else {
                            return null
                          }
                        })}
                    </ConfirmSection>
                  )
                })}
              </ConfirmStep>
            ) : null
          )}
        </div>
      </div>
    )
  }
}
export default connect(state => {
  return {
    steps: state.wizard.wizard.stepOrder.map(stepId => state.wizard.wizard.steps[stepId]),
    sections: state.wizard.wizard.sections,
    fields: state.wizard.wizard.fields,
    mode: state.wizard.mode,
    originalValues: state.wizard.diff.original,
    originalByFieldId: state.wizard.diff.originalByFieldId,
    showDiff: state.wizard.showDiff
  }
})(Summary)

const ConfirmStep = ({ title, children, mode }) =>
  React.Children.toArray(children).filter(
    child => child.props.children.filter(subchild => subchild).length > 0
  ).length > 0 && (
    <div className="col-12 confirm-col">
      <div className="confirm-step">
        <h4 className="title">{title}</h4>
        {children}
      </div>
    </div>
  )

const ConfirmSection = ({ title, children, mode }) =>
  React.Children.toArray(children).length > 0 && (
    <div className="confirm-section">
      <h4 className="section-title">{title}</h4>
      {children}
    </div>
  )

const ConfirmField = ({ label, value, colSpan }) => (
  <div className="row field-divider">
    {colSpan !== 'col-12' ? (
      <div className={colSpan}>
        <i>{label}</i>
      </div>
    ) : null}
    <div className={colSpan + ' value'}>
      <b>{value && value !== undefined && value !== "" ? value : <span className="visually-hidden">No entry</span>}</b>
    </div>
  </div>
)

const DumbRepeater = ({
  fieldId,
  ame,
  label,
  template,
  value,
  emptyRepeaterLabel,
  displayType,
  trackChanges,
  showChangesOnForm,
  showChangesOnSummary,
  noDeletedStylingOnSummary,
  originalByFieldId
}) => {
  const fields = store.getState().wizard.wizard.fields
  const filteredTemplate = template
    .filter(item => fields[item].fieldClass !== 'Paragraph')
    .filter(item => fields[item].active && !fields[item].hideInRepeaterGrid)
  return (
    <div className="row field-divider">
      <span className="repeats-wrapper">
        {/* {
          label !== "" ? <i>{label}</i> : null
        } */}
        <div className="repeats dumb-repeats">
          <table className="form-table">
            <thead>
              <tr>
                {filteredTemplate.map((fieldId, i) => (
                  <th key={i}>
                    {fields[fieldId].shortLabel !== ''
                      ? fields[fieldId].shortLabel
                      : fields[fieldId].label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {value.length === 0 && emptyRepeaterLabel !== '' ? (
                <tr className="repeats-row">
                  <td className="no-entries" colSpan={filteredTemplate.length}>
                    {emptyRepeaterLabel === '' ? 'None' : emptyRepeaterLabel}
                  </td>
                </tr>
              ) : (
                value.map((row, i) => (
                  <DumbRow
                    fieldId={fieldId}
                    trackChanges={trackChanges}
                    showChangesOnForm={showChangesOnForm}
                    showChangesOnSummary={showChangesOnSummary}
                    noDeletedStylingOnSummary={noDeletedStylingOnSummary}
                    originalByFieldId={originalByFieldId}
                    row={row}
                    rowIndex={i}
                    key={i}
                  />
                ))
              )}
            </tbody>
          </table>
        </div>
      </span>
    </div>
  )
}

const DumbRow = ({
  fieldId: parentFieldId,
  row,
  trackChanges,
  showChangesOnForm,
  showChangesOnSummary,
  noDeletedStylingOnSummary,
  originalByFieldId,
  rowIndex
}) => {
  const fields = store.getState().wizard.wizard.fields
  const getCellValue = (fieldId, value) => {
    let field = fields[fieldId]
    let fieldClass = new WizardClasses[field.fieldClass]()
    return fieldClass.getHumanReadableValue(field, value)
  }
  const deleting = row._statusId === 3
  const added = row._statusId === 1
  const edited = row._statusId === 2
  return (
    <tr
      className={`repeats-row ${deleting && trackChanges ? 'deleting' : ''} ${
        added && trackChanges ? 'adding' : ''
      } ${edited && trackChanges ? 'edited' : ''}
      ${noDeletedStylingOnSummary ? 'hide-strikethrough' : ''}
      `}
    >
      {Object.keys(row)
        .filter(
          fieldId =>
            fieldId.charAt(0) !== '_' &&
            fields[fieldId].active &&
            (showChangesOnSummary && trackChanges ? deleting || added || edited : true) &&
            !(fields[fieldId] || {}).hideInRepeaterGrid
        )
        .map((fieldId, i) => {
          return fields[fieldId].fieldClass !== 'Paragraph' ? (
            edited && trackChanges && showChangesOnForm ? (
              <HistoryCell
                original={(originalByFieldId[parentFieldId][rowIndex] || {})[fieldId]}
                current={row[fieldId]}
                getCellValue={getCellValue}
                edited={edited}
                originalByFieldId={originalByFieldId}
                fieldId={fieldId}
                key={i}
              />
            ) : (
              <td key={i}>{getCellValue(fieldId, row[fieldId])}</td>
            )
          ) : null
        })}
    </tr>
  )
}

const HistoryCell = ({ original, fieldId, originalByFieldId, current, getCellValue, edited }) =>
  !deepEqual(original, current) && edited && original && current ? (
    <td>
      <div className="cell-history">
        <span className="label">Changed From: </span>
        <span className="before">{getCellValue(fieldId, original)}</span>
        <span className="label">Changed To: </span>
        <span className="after">{getCellValue(fieldId, current)}</span>
      </div>
    </td>
  ) : (
    <td>{getCellValue(fieldId, current)}</td>
  )

const SummarySignatures = ({ srcRepeater, srcField, value, multiple }) => {
  const fields = store.getState().wizard.wizard.fields
  const repeaterRows = fields[srcRepeater] ? fields[srcRepeater].value : []
  const columnField = fields[srcField]
    ? new WizardClasses[fields[srcField].fieldClass](fields[srcField])
    : null
  return (
    <div className="summary-signatures field-divider">
      {multiple ? (
        columnField &&
        repeaterRows.map((row, i) => {
          const signature = value[i] ? value[i] : {}
          return (
            <SummarySignatureRow
              name={columnField.getHumanReadableValue(columnField, row[columnField.fieldId])}
              signature={signature}
              key={i}
            />
          )
        })
      ) : (
        <SummarySignatureRow name="Signature" signature={value[0] || {}} />
      )}
    </div>
  )
}

const SummarySignatureRow = ({ name, signature }) => (
  <div className="row signature-row">
    <div className="col-md-9">
      <span className="signature"> {signature.sig}</span>
      <br />
      <span className="name">{name}</span>
    </div>
    <br />
    <div className="col-md-3">
      <span className="signature">{format(new Date(signature.date), 'MM/dd/yyyy')}</span>
      <br />
      <span className="name">Date</span>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/Summary.js